module.exports = __webpack_public_path__ + "img/telefono.da4d7ebb.svg";